/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'

import { isEmpty } from 'lodash'

import { Filters } from 'components'

import { useFetch } from 'hooks'

import helpers from 'helpers'
import * as service from 'service'

const UserProfilesFilter = ({ filter, isAdvisor }) => {
  const [companies, setCompanies] = useState([])
  const [companyInputValue, setCompanyInputValue] = useState('')
  const [organizationInputValue, setOrganizationInputValue] = useState('')
  const [isLoadingCompaniesInput, setIsLoadingCompaniesInput] = useState(false)
  const [isLoadingCompanies, setIsLoadingCompanies] = useState(false)

  const {
    loadCompanies,
    mountCompanyParams,
    instructionsText: companyInstructionsText,
  } = helpers.companies.typeAndSearch
  const {
    mountOrganizationParams,
    instructionsText: organizationInstructionsText,
  } = helpers.organizations.typeAndSearch

  const { nameWithDocumentByArrayObject } = helpers.companies.nameWithDocument
  const { filters, drawerOpen } = filter

  const handleTypeCompaniesInput = (e) => {
    setCompanyInputValue(e.target.value)
  }
  const handleTypeOrganizationInput = (e) => {
    setOrganizationInputValue(e.target.value)
  }

  const companiesOptionsValues = nameWithDocumentByArrayObject(
    isLoadingCompaniesInput ? [] : companies,
  )

  useEffect(() => {
    const getCompanies = setTimeout(() => {
      const hasCompanyValueToFetch =
        companyInputValue.length < 3 && isEmpty(filters?.companyId)

      if (hasCompanyValueToFetch || !drawerOpen) return

      loadCompanies(
        mountCompanyParams(companyInputValue, filters),
        setIsLoadingCompaniesInput,
        setCompanies,
      )
    }, 1000)

    return () => {
      clearTimeout(getCompanies)
    }
  }, [companyInputValue])

  const { response, isStillLoading: isStillOrganizationsLoading } = useFetch(
    service.backoffice.organizations.get,
    mountOrganizationParams({ organizationInputValue, filters }),
    [filters?.organizationId],
    organizationInputValue.length >= 3,
  )

  const organizations = response?.data?.organizations || []

  useEffect(() => {
    if (filters?.companyId) {
      loadCompanies(
        mountCompanyParams(companyInputValue, filters),
        setIsLoadingCompanies,
        setCompanies,
      )
    }
  }, [filters?.companyId])

  useEffect(() => {
    if (!drawerOpen && companyInputValue) setCompanyInputValue('')
  }, [drawerOpen])

  return (
    <Filters filter={filter} isLoading={isLoadingCompanies}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Nome" name="name" />
      {isAdvisor ? (
        <select
          autocompleteselectinput="true"
          label="Grupo Advisor"
          name="organizationId"
          loading={isStillOrganizationsLoading}
          onChangeTypeSearch={handleTypeOrganizationInput}
          optionvalues={organizations}
          noOptionsText={organizationInstructionsText({
            organizationInputValue,
          })}
        />
      ) : (
        <select
          autocompleteselectinput="true"
          label="Empresa"
          name="companyId"
          loading={isLoadingCompaniesInput}
          onChangeTypeSearch={handleTypeCompaniesInput}
          optionvalues={companiesOptionsValues}
          noOptionsText={companyInstructionsText(companyInputValue)}
        />
      )}
      <select textfieldinput="true" label="Categoria de perfil" name="default">
        <option value=""></option>
        <option value={false}>
          Perfil de {isAdvisor ? 'Grupo Advisor' : 'empresa'}
        </option>
        <option value={true}>Perfil sugerido</option>
      </select>
    </Filters>
  )
}

export default UserProfilesFilter
